/*
 * @Author: your name
 * @Date: 2021-12-02 16:55:35
 * @LastEditTime: 2021-12-02 16:58:05
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \vue3-element-admin\src\store\modules\app\MyMap.js
 */
import {
    SET_WARING_INFO,
    SET_CURENT_GARDEN
} from "./type.js";
export default {
    namespaced: true,
    state: {
        _7d:[]
    },
    mutations: {
        [SET_WARING_INFO](state, warningInfo) {
            state.warningInfo = warningInfo
            sessionStorage.setItem("warningInfo", warningInfo);
        },
        [SET_CURENT_GARDEN](state, curentGarden) {
            state.curentGarden = curentGarden
            sessionStorage.setItem("curentGarden", curentGarden);
        },
    },
    actions: {
        [SET_WARING_INFO]({ commit }, warningInfo) {
            commit(SET_WARING_INFO, warningInfo);
        },
        [SET_CURENT_GARDEN]({ commit }, curentGarden) {
            commit(SET_CURENT_GARDEN, curentGarden);
        },
    },
};
